import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import { redPointType, hotNewType } from '@/views/zhiji/js/common/constants';
import i18n from "@/i18n";

export default {
    widgetName: "HotRecommend",
    serverType: "hot_questions",
    initContent() {
      // 热点组件的初始数据
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "HotRecommend",
            content: [
              {
                uId: uniqueId(),
                items: initHotItem()
              }
          ]
        };
    },
    initItem(item) {
        return {
            uId: uniqueId(),
            wtType: item.type,
            updateState: "add"
        };
    },
    // 上线前检查content参数
    checkContent(content) {
        content.content.forEach(middle => {
            if (!middle.title) {
                throw new ParamError(i18n.t("zhiji.answer.hotComponentTitleTip"));
            }
            middle.items.forEach(item => {
                if (item.hotTitle.replace(/(^\s*)|(\s*$)/g, "") == "") {
                    throw new ParamError(i18n.t("zhiji.answer.hotTitleTip"));
                }
                if (!item.questionId) {
                    throw new ParamError(i18n.t("zhiji.answer.linkQuestion"));
                }
            });
        })
    },
    // 把接收到的数据转成客户端需要的结构
    server2Client(content) {
        return {
            uId: uniqueId(),
            wtType: "HotRecommend",
            updateState: "add",
            content: content.content.map(item => {
              return {
                uId: uniqueId(),
                items: cvtHotItemClient(item.questions),
                title: item.title
              }
            }),
        };
    },
    // 转成后台需要的结构
    client2Server(content) {
        return {
          type: 'hot_questions',
          content: content.content.map(item => {
            return {
              id: "", //暂时无用，默认为空
              title: item.title,
              questions: cvtHotItemParams(item.items)
            }
          })
        };
      },
};

// 初始化热点推荐问题列表，默认两条
function initHotItem() {
    let initItem = Array(2).fill(uniqueId());
    initItem = initItem.map(() => {
        return {
            uId: uniqueId(),
            wtType: "HotEditItem",
            hotTitle: "",
            question: "",
            questionId: "",
            redState: 'off',
            hotItem: 'NEW',
            redHotEndTime: '',
        }
    });

  return initItem;
}

// 热点每个子项参数转换成后台需要的结构
function cvtHotItemParams(itemParams) {
    let serveParams = [];
    serveParams = itemParams.map(item => {
        return {
            question: item.question,
            question_id: item.questionId,
            question_display_text: item.hotTitle,
            hot_switch: item.redState !== 'on' ? redPointType.OFF : item.hotItem == 'NEW' ? hotNewType.NEW : hotNewType.HOT,
            hot_new_end_time: item.redHotEndTime || '',
        };
    });

    return serveParams;
}

function cvtHotSwitch(value) {
    let status = 'off';
    if(!value || redPointType.OFF == value) {
        status = 'off'
    } else if(value == '1' || value == '2') {
        status = 'on'
    }
    return status;
}

// 热点子项客户端数据
function cvtHotItemClient(data) {
    let result = [];
    result = data.map(item => {
        return {
            question: item.question,
            questionId: item.question_id,
            hotTitle: item.question_display_text,
            uId: uniqueId(),
            wtType: "HotEditItem",
            redState: cvtHotSwitch(item.hot_switch),  // 0：不开启 1：hot 2：new
            hotItem: hotNewType.NEW == item.hot_switch ? 'NEW' : 'HOT',
            redHotEndTime: item.hot_new_end_time || '',
        };
    });

    return result;
}
